import Menu from "./components/menu/Menu";
import Advertising from './components/Advertising';
import Home from "./pages/Home";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Contacts from "./pages/Contacts";
import Projects from "./pages/Projects";
import Project from "./pages/Project";
import Order from "./pages/Order";
import NotFound from "./pages/notfound";

import './styles/main.css';

function App() {
  return (
    <>
    <Router>
      <Menu />
       <Advertising />
      <div className="body">
        <Routes>
          <Route path="/" element ={<Home />} />
          <Route path="/order" element ={<Order />} />
          <Route path="/projects" element ={<Projects />} />
          <Route path="/project/:name" element ={<Project />} />
          <Route path="/contacts" element ={<Contacts />} />
          <Route path="*" element={<NotFound/>}  />
        </Routes>
      </div>

     
    </Router>
    </>
  );
}

export default App;
